import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable, Duration_fromTransferable, Duration_toTransferable, } from "./DateTime";
import { GridSamplingStrategyKind } from "./GridSamplingStrategy";
import { WORLD_BBOX } from "../bounds";
/**
 * Serializes non-cloneable request members for postMessage/thread transport.
 */
export function LightningListRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area.toTransferable(),
        datetime: DateTime_toTransferable(req.datetime),
        timeDuration: Duration_toTransferable(req.timeDuration),
    };
}
/**
 * Restores a transferable lightning request to runtime objects.
 */
export function LightningListRequest_fromTransferable(req) {
    return {
        ...req,
        area: Area.fromTransferable(req.area),
        datetime: DateTime_fromTransferable(req.datetime),
        timeDuration: Duration_fromTransferable(req.timeDuration),
    };
}
/**
 * Adapts a lightning request into GridRequest shape for shared URL builders.
 * Only area-related fields are consumed by that path.
 */
export function LightningListRequest_toGridRequest(lightningListRequest) {
    return {
        ...lightningListRequest,
        boundingBoxLimit: WORLD_BBOX,
        height: 0,
        model: "",
        width: 0,
        parameters: [""],
        sampling: { kind: GridSamplingStrategyKind.Point }
    };
}
//# sourceMappingURL=LightningListRequest.js.map